export default "__VITE_ASSET__5393884c__"